import React, { useState, useEffect } from 'react';
import { heroImages as defaultHeroImages } from '../mock';
import VirtualTryOn from './VirtualTryOn';

const BACKEND_URL = '';

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showVirtualTryOn, setShowVirtualTryOn] = useState(false);
  const [heroImages, setHeroImages] = useState(defaultHeroImages);

  useEffect(() => {
    // Fetch hero images from database
    const fetchHeroImages = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/site-settings/hero`);
        if (response.ok) {
          const data = await response.json();
          if (data.images && data.images.length > 0) {
            setHeroImages(data.images);
          }
        }
      } catch (error) {
        console.error('Error fetching hero images:', error);
      }
    };
    fetchHeroImages();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroImages.length]);

  return (
    <>
      <section className="relative h-[700px] md:h-[800px] overflow-hidden">
        {/* Image Carousel */}
        {heroImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img 
              src={image} 
              alt="Fashionable eyewear" 
              className="w-full h-full object-cover object-center"
            />
            {/* Gradient overlay - darker at bottom for text readability */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
          </div>
        ))}

        {/* Text at very bottom */}
        <div className="absolute bottom-28 left-0 right-0 z-10">
          <div className="container mx-auto px-4 text-center">
            <div className="max-w-5xl mx-auto text-white">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif leading-tight" style={{ fontFamily: 'Georgia, "Times New Roman", Times, serif' }}>
                Streetsville Eyecare-Optometrist &
              </h1>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif leading-tight mb-2" style={{ fontFamily: 'Georgia, "Times New Roman", Times, serif' }}>
                Eyeglasses Streetsville, Mississauga
              </h1>
              <p className="text-base md:text-lg" style={{ fontFamily: 'Georgia, "Times New Roman", Times, serif' }}>
                Specializing in custom lenses and boutique designer glasses not found anywhere else!
              </p>
            </div>
          </div>
        </div>

        {/* Virtual Mirror Button */}
        <button 
          onClick={() => setShowVirtualTryOn(true)}
          className="absolute top-4 left-4 md:left-8 bg-black/70 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg flex items-center gap-2 hover:bg-black/90 transition-colors z-10 text-sm md:text-base"
        >
          <span className="font-medium">Virtual Mirror</span>
          <svg className="w-5 h-5 md:w-6 md:h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
        </button>
      </section>

      {/* Virtual Try-On Modal */}
      <VirtualTryOn 
        isOpen={showVirtualTryOn} 
        onClose={() => setShowVirtualTryOn(false)} 
      />
    </>
  );
};

export default Hero;
